import { Injectable, inject } from '@angular/core';
import { LanguageCode } from '@job-v2/ats-utils';
import { StatesService, StateStoreKeys } from '@socium/sociumflow';

/**
 * Service to manage language settings and preferences.
 */
@Injectable({ 
  providedIn: 'root' 
})
export class LanguageService {
  private readonly statesService = inject(StatesService);

  saveChangeLang(lang: string): void {
    this.statesService.setCookie(StateStoreKeys.LANGUAGE, lang.toUpperCase());
  }

  getUserLang(): string {
    return (this.statesService.getCookie<string>(StateStoreKeys.LANGUAGE) ||
    navigator.language  || LanguageCode.FR.toLowerCase()).toLowerCase();
  }

  setUserLang(): void {
    const userLang = this.getUserLang();
    const language: string = userLang.split('-')[0];
    this.statesService.setCookie(StateStoreKeys.LANGUAGE, language.toUpperCase());
  }

  getUserTranslateLanguage(): string {
    const lang = this.statesService.getCookie<string>(StateStoreKeys.LANGUAGE);
    if (!lang) {
      this.setUserLang();
    }
    return this.getUserLang();
  }

  getBrowserLanguage(): string {
    const lang = navigator.language || navigator.languages[0] || 'fr-FR';

    if (lang.startsWith('fr')) return 'fr-FR';
    if (lang.startsWith('en')) return 'en-US';

    return 'fr-FR';
  }
}
